module.exports = __webpack_public_path__ + "img/bank-input.e3dc7327.png";